import React, {useState} from 'react';
import { useMediaQuery } from "react-responsive";

import Button from '@mui/joy/Button';
import Sheet from '@mui/joy/Sheet';
import Typography from '@mui/joy/Typography';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import {Stack} from "@mui/joy";
import Navbar from "./Navbar";

const Login = ({onLogin, authProvider}) => {
    const isMobile = useMediaQuery({ query: "(max-width: 600px)" });
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = () => {
        authProvider.login(username, password).then((data) => {
            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);
            onLogin();
        });
    };

    return (
        <>
            <Navbar/>
            <Stack sx={{
                width: isMobile ? '90%' : '400px',
                mx: 'auto',
                mt: isMobile ? '40%' : '10%',
                py: 3,
                px: 3,
            }}>
                <Typography level="h2">Вход</Typography>
                <Sheet sx={{
                    mt: 3,
                    py: 3,
                    px: 3,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2,
                    borderRadius: 'lg',
                    backgroundColor: '#FFFFFF',
                    borderColor: '#E5E5E5',
                }} variant="outlined">
                    <FormControl>
                        <FormLabel>Логин</FormLabel>
                        <Input
                            type="text"
                            placeholder="Введите ваш логин"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Пароль</FormLabel>
                        <Input
                            type="password"
                            placeholder="Введите пароль здесь"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </FormControl>
                </Sheet>
                <Button sx={{mt: 3, p: 1.5, borderRadius: 'md'}} variant="solid" onClick={handleLogin}>Далее</Button>
            </Stack>
        </>
    );
};

export default Login;
